<template lang="pug">
.toggle-row
  aiq-switch(:model-value="config.enable" @change="onEnabled"
      style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")
  h3.title {{ $t('settings_tab.admin_tab.feedback_interval.title') }}
  aiq-tooltip(:content="$t('settings_tab.admin_tab.feedback_interval.tooltip')"
    placement="top")
    fa-icon.question-mark(:icon="['fas', 'circle-question']")

.form-field-container(v-if="config.enable")
  .form-field-label {{ $t('settings_tab.admin_tab.feedback_interval.interval') }}
  aiq-input.interval-input(v-model="config.feedback_interval"
      :placeholder="$t('settings_tab.admin_tab.feedback_interval.interval_placeholder')"
      size="small"
      type="number"
      :min="0"
      @keydown.enter="saveInterval()")
</template>

<script>
export default {
  name: 'feedback-interval',
  data() {
    return {
      config: {
        enable: false,
        feedback_interval: 0,
      },
    };
  },
  async mounted() {
    this.config = await this.$store.dispatch('settings/getSetting', {
      name: 'feedback_interval',
    });
  },
  methods: {
    onEnabled(value) {
      this.config.enable = value;
      this.saveInterval();
    },
    async saveInterval() {
      try {
        this.config.feedback_interval = parseInt(this.config.feedback_interval);
        if (isNaN(this.config.feedback_interval) || this.config.feedback_interval < 0) {
          this.$aiq.notify.info(this.$t('settings_tab.admin_tab.feedback_interval.invalid_days'));
          return;
        }
        await this.$store.dispatch('settings/updateSetting', {
          name: 'feedback_interval',
          payload: this.config,
        });
        this.$aiq.notify.success(this.$t('settings_tab.admin_tab.feedback_interval.success'));
      } catch (error) {
        this.$aiq.notify.error(this.$t('settings_tab.admin_tab.feedback_interval.error'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-field-container {
  margin-top: 16px;
  margin-bottom: 16px;
}
.form-field-label {
  font-weight: bold;
  margin-bottom: 8px;
}

.interval-input {
  width: 250px;
}
</style>